import { render, staticRenderFns } from "./LocalSearch.vue?vue&type=template&id=0ef73370&scoped=true&"
import script from "./LocalSearch.vue?vue&type=script&lang=js&"
export * from "./LocalSearch.vue?vue&type=script&lang=js&"
import style0 from "./LocalSearch.vue?vue&type=style&index=0&id=0ef73370&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef73370",
  null
  
)

export default component.exports